t = require('views/internal/teacup-with-helpers')('calendar_day_list_header')

module.exports = ->
  t.span '.calendar-list-header', { name: t.mustacheVar('listID') }, ->
    t.icon 'list'
    t.text ' '
    t.text t.mustacheVar('listName')



// WEBPACK FOOTER //
// ./app/scripts/views/templates/calendar_day_list_header.coffee